import { render, staticRenderFns } from "./Passenger.vue?vue&type=template&id=fb620338&scoped=true"
import script from "./Passenger.vue?vue&type=script&lang=js"
export * from "./Passenger.vue?vue&type=script&lang=js"
import style0 from "./Passenger.vue?vue&type=style&index=0&id=fb620338&prod&lang=css"
import style1 from "./Passenger.vue?vue&type=style&index=1&id=fb620338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb620338",
  null
  
)

export default component.exports